module.exports = __webpack_public_path__ + "static/media/lifestyle1-large.2f930482.jpg";